import I18nForLwText from './LwText'

export default class I18nForLwDateTime extends I18nForLwText {
  name = 'lw-date-time'
}
